import type { SVGProps } from "react";
const SvgCheckedBaggageDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <radialGradient
        id="checkedBaggageDisabled_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.4 0 0 1.4 21.517 28.528)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.462} stopColor="#BCBCBC" />
        <stop offset={0.759} stopColor="#A2A2A2" />
        <stop offset={0.829} stopColor="#AAA" />
      </radialGradient>
      <radialGradient
        id="checkedBaggageDisabled_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.4 0 0 1.4 10.481 28.528)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.462} stopColor="#BCBCBC" />
        <stop offset={0.759} stopColor="#A2A2A2" />
        <stop offset={0.829} stopColor="#AAA" />
      </radialGradient>
      <radialGradient
        id="checkedBaggageDisabled_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(.2 10.9 -14 .6 16.006 16.67)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.63} stopColor="#DEDEDE" />
        <stop offset={1} stopColor="#C5C5C5" />
      </radialGradient>
      <linearGradient
        id="checkedBaggageDisabled_svg__c"
        x1={21.517}
        x2={21.517}
        y1={27.845}
        y2={28.431}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="checkedBaggageDisabled_svg__e"
        x1={10.481}
        x2={10.481}
        y1={27.845}
        y2={28.431}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <filter
        id="checkedBaggageDisabled_svg__a"
        width={20.6}
        height={3.8}
        x={5.699}
        y={28.102}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={0.75} />
      </filter>
    </defs>
    <g filter="url(#checkedBaggageDisabled_svg__a)" opacity={0.5}>
      <ellipse cx={16} cy={30} fill="#000" rx={8.8} ry={0.4} />
    </g>
    <path
      fill="#DBDBDB"
      d="M22.07 6.45H20v-.69c0-.38.31-.69.69-.69h.69c.38 0 .69.31.69.69zM12 6.45H9.93v-.69c0-.38.309-.69.69-.69h.69c.38 0 .69.31.69.69zm6.073-3.446h-4.14v2.76h-1.378v-2.76a1.38 1.38 0 0 1 1.379-1.379h4.14c.76 0 1.379.617 1.38 1.38v2.76h-1.38z"
    />
    <path
      fill="url(#checkedBaggageDisabled_svg__b)"
      d="M21.517 29.908a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76"
    />
    <path
      fill="url(#checkedBaggageDisabled_svg__c)"
      d="M21.517 27.148c.762 0 1.38.618 1.38 1.38h-2.76c0-.762.617-1.38 1.38-1.38"
      opacity={0.2}
    />
    <path
      fill="url(#checkedBaggageDisabled_svg__d)"
      d="M10.481 29.908a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76"
    />
    <path
      fill="url(#checkedBaggageDisabled_svg__e)"
      d="M10.481 27.148c.763 0 1.38.618 1.38 1.38h-2.76c0-.762.618-1.38 1.38-1.38"
      opacity={0.2}
    />
    <path
      fill="url(#checkedBaggageDisabled_svg__f)"
      d="M21.932 5.762H10.066a2.07 2.07 0 0 0-2.07 2.07v17.936a2.07 2.07 0 0 0 2.07 2.07h11.866a2.07 2.07 0 0 0 2.07-2.07V7.831a2.07 2.07 0 0 0-2.07-2.07Z"
    />
    <path
      fill="#B4B4B4"
      d="M19.45 3.695h-6.9v-.69c0-.763.618-1.38 1.38-1.38h4.14c.762 0 1.38.617 1.38 1.38z"
    />
    <path
      fill="#fff"
      d="M14.962 8.523a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m-2.066 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m-2.071 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m6.207 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m2.071 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m2.07 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345"
      opacity={0.2}
    />
    <path stroke="#fff" strokeWidth={4} d="M5.246 26.272 25.762 5.76" />
    <path stroke="#B4B4B4" strokeWidth={1.5} d="M6.246 27.272 26.762 6.76" />
  </svg>
);
export default SvgCheckedBaggageDisabled;
